
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card error-500-page\">\n  <header>\n    <h1 id=\"fxa-500-header\" class=\"card-header\">{{#t}}500 Error{{/t}}</h1>\n  </header>\n\n  <section>\n    <details>\n      <summary>{{#t}}Oh dear, something went wrong there. We've been notified and will get working on a fix.{{/t}}</summary>\n      <pre id=\"fxa-500-error-context\">{{stack}}</pre>\n    </details>\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  